<template>
  <div class="switch-wrapper" :class="{ active: value, inactive:!value, disabled }">
    <div class="text-content bs-flex bs-item-center bs-content-between">
      <div class="confirm" @click="toggle">{{ activeText }}</div>
      <div class="cancel" @click="toggle">{{ inactiveText }}</div>
    </div>
    <div class="switch-inner"></div>
  </div>
</template>

<script>
  import { Component, Vue, Prop, Model } from 'vue-property-decorator';

  @Component
  export default class PreferencesSwitch extends Vue {
    @Model('input', { type: Boolean, default: false }) value
    @Prop({ type: Boolean, default: false }) disabled
    @Prop({ type: String, default: 'Yes' }) activeText  // switch 打开时的文字描述
    @Prop({ type: String, default: 'No' }) inactiveText  // switch 关闭时的文字描述

    toggle() {
      this.$emit('input', !this.value);
      this.$emit('click-change');
    }
  }
</script>

<style lang="scss">
  .switch-wrapper {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    border-radius: 29px;
    font-size: 24px;
    background: var(--bg-secondary-gray) 0% 0% no-repeat padding-box;
    transition: all .3s;
    cursor: pointer;

    .text-content {
      box-sizing: border-box;
      height: 100%;
      font-weight: 600;

      .confirm {
        z-index: 10;
        width: 100%;
        padding: 16px 40px;
        color: var(--font-secondary-black);
      }

      .cancel {
        z-index: 10;
        width: 100%;
        padding: 16px 40px;
        color: var(--font-third-gray);
      }
    }

    .switch-inner {
      position: absolute;
      top: 0;
      width: 50%;
      height: 100%;
      border-radius: 29px;
      background: var(--bg-primary-gray);
      transform: translateX(100%);
      transition: all .3s;
    }

    &.active {
      .switch-inner {
        background: var(--bg-primary-purple) 0% 0% no-repeat padding-box;
        transform: translateX(0);
      }

      .confirm {
        color: var(--font-primary-white);
      }

      .cancel {
        color: var(--font-primary-black);
      }
    }

    &.disabled {
      opacity: 0.6;
    }
  }
</style>
